/*
  RMS ZEITMEISTER - Ulke/dil panelini ilk izlenimden sonraya erteler (17 Agustos 2026)

  Olculdu: anasayfaya giren Turkiye'li ziyaretci ~1,5 sn icinde ekranin tamamini kaplayan
  bir panelle karsilasiyor, arkasindaki sayfayi hic gormeden karar vermesi isteniyordu;
  ustelik <html> uzerinde overflow:hidden ile kaydirma da kilitleniyordu.
  Trafigin %79'u Turkiye. SimGym: Adelaide 17 sn'de 0 tiklamayla cikti.

  Yontem: bolumun ic mantigina dokunulmaz. Panel acilmaya calistigi an DOM'da yakalanip
  geri kapatilir. Ziyaretci GERCEK bir hareket yapinca (tekerlek, dokunma, klavye) ya da
  RMS_GEO_DELAY_MS sonunda izin verilir ve panel acilir.

  TUZAK: 'scroll' olayi kullanilamaz - tarayici sayfa yenilendiginde onceki kaydirma
  konumunu geri yukleyip sahte scroll uretiyor, panel yine hemen aciliyordu (olculdu).
  Bu yuzden yalnizca dogrudan kullanici olaylari dinlenir.

  Durum: window.RMS_GEO_DEFER  -  Geri alma: theme.liquid'deki iki satiri sil.
*/
(function () {
  var KEY = 'rms-geo-choice-v1';
  var DELAY = (window.RMS_GEO_DELAY_MS === undefined) ? 10000 : window.RMS_GEO_DELAY_MS;
  var ARM_MS = 1200;
  var EVENTS = ['wheel', 'touchmove', 'keydown', 'pointerdown'];

  var S = window.RMS_GEO_DEFER = { calisti: true, atlandi: null, bagli: false, bastirma: 0, izin: false, bekliyor: false, hazir: false, tetik: null };

  if (/[?&]rms-geo=(test|reset)/.test(window.location.search)) { S.atlandi = 'test-parametresi'; return; }
  try { if (localStorage.getItem(KEY)) { S.atlandi = 'secim-var'; return; } } catch (e) {}

  var modal = null;

  function suppress() {
    if (!modal || S.izin) return;
    if (modal.classList.contains('is-open') || modal.hidden === false) {
      modal.classList.remove('is-open');
      modal.hidden = true;
      document.documentElement.classList.remove('rms-geo-open');
      document.documentElement.style.overflow = '';
      S.bekliyor = true;
      S.bastirma++;
    }
  }

  function allow(kaynak) {
    if (S.izin) return;
    S.izin = true;
    S.tetik = kaynak;
    EVENTS.forEach(function (t) { window.removeEventListener(t, onUser); });
    if (!S.bekliyor) return;
    var n = 0;
    (function press() {
      var b = document.querySelector('[data-rms-geo]');
      if (b) { b.click(); return; }
      if (++n <= 24) setTimeout(press, 250);
    })();
  }

  function onUser(e) { if (S.hazir && (!e || e.isTrusted !== false)) allow(e && e.type); }

  var tries = 0;
  var iv = setInterval(function () {
    if (!modal) {
      modal = document.getElementById('rms-geo');
      if (modal) {
        S.bagli = true;
        new MutationObserver(suppress).observe(modal, { attributes: true, attributeFilter: ['class', 'hidden'] });
      }
    }
    suppress();
    if (modal && (S.izin || ++tries > 600)) clearInterval(iv);
  }, 25);

  EVENTS.forEach(function (t) { window.addEventListener(t, onUser, { passive: true }); });

  window.addEventListener('load', function () {
    setTimeout(function () { S.hazir = true; }, ARM_MS);
  });

  if (DELAY > 0) setTimeout(function () { allow('sure'); }, DELAY);
})();
